
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import * as ko from "knockout";
import * as $ from "jquery";
import BaoDialog from "./../../factories/bao-dialog";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import TaskViewModel from "./../../view-models/task";
import CreateEvaluationDialog from "./../../view-models/dialogs/create-evaluation-dialog";


/**
 * ViewModel for the Checklist tab in the Tasks
 * */
class TaskEvaluationTab extends SubscriptionViewModel {
    TabPage;
    Bao = Bao;
    taskVM: KnockoutObservable<any>;
    OriginalTabTitle: string = "";

    CompleteCheck = () => {
        return true;
    };

    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    EvaluationCollection = ko.observableArray([]);

    SelectRow = (item) => {
        this.SelectedEvaluationRow(item);
        return true;
    }
    SelectedEvaluationRow = ko.observable<any>({});
    enableButton: (actionpKey: string, enabled: boolean) => void;
    ToolbarBtns = null;

    baoToolbar2TaskEvaluationShowButton: (actionKey: string, visible: boolean) => void;

    constructor(taskVM: any, tabPage: any) {
        super(tabPage);
        this.TabPage = tabPage;
        this.taskVM = ko.observable(taskVM);

        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });
        this.SelectedEvaluationRow.subscribe(() => {
            if (this.SelectedEvaluationRow() == null) {
                if (this.enableButton != undefined) {
                    this.enableButton("TaskEvaluationEdit", false);
                    this.enableButton("TaskEvaluationDelete", false);
                }
            } else {
                if (this.enableButton != undefined) {
                    this.enableButton("TaskEvaluationEdit", true);
                    this.enableButton("TaskEvaluationDelete", Bao.Utils.String.IsNullOrWhitespace(this.SelectedEvaluationRow().CompleteDateJs));
                }
            }
        });

        Bao.bindEvent('checklist-evaluation:refresh', () => this.Refresh());
    }

    toolbarLoaded = () => {
        this.setPermissions();
    };

    toolbarButtonClicked = (action) => {
        switch (action.ActionKey()) {
            case "TaskEvaluationAdd":
                this.ShowCreateEvaluationDialog(this.taskVM().ReportId());
                break;
            case "TaskEvaluationEdit":
                if (this.SelectedEvaluationRow() != null) {
                    this.EditReportEvaluation(this.SelectedEvaluationRow());
                }
                break;
            case "TaskEvaluationDelete":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteReportEvaluation"), "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.DeleteReportEvaluation(this.SelectedEvaluationRow());
                    }
                });
                break;
            case "TaskEvaluationRefresh":
                this.RefreshGrid();
                break;
        }
    }

    RefreshGrid = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("EvaluationTab/GetEvaluationCollectionByInstructionId", JSON.stringify({
            instructionId: this.taskVM().InstructionId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedEvaluationRow(null);
            this.TotalRows(0);
            this.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.EvaluationCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + this.TotalRows() + ")");
        });
    }

    CreateEvaluation = (folderStructureChecklistId, instructionId) => {
        this.TabPage.IsLoading(true);
        return Bao.post("EvaluationTab/CreateEvaluationByInstruction", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            instructionId: instructionId
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        }).then(_ => Bao.raiseEvent('checklist-evaluation:refresh', null));
    }

    DeleteReportEvaluation = (item) => {
        Bao.post("EvaluationTab/DeleteEvaluation", JSON.stringify({
            evaluationId: ko.unwrap(item.EvaluationId)
        }), () => {
            this.RefreshGrid();
        });
    }

    EditReportEvaluation = (item) => {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    }

    ShowCreateEvaluationDialog = (reportId) => {
        var dialog = new CreateEvaluationDialog(this.TabPage, this);
        dialog.Show();
        dialog.DialogResult.subscribe((dialogResult) => {
            if (dialogResult == true) {
                this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), this.taskVM().InstructionId());
            }
        });
    };

    Refresh = () => {
        return this.RefreshGrid();
    };

    Save = () => { };

    init = () => {
        this.OriginalTabTitle = this.TabPage.Title();
    }

    loaded = () => {
        return Bao.post('EvaluationTab/LoadColumns', (result) => {
            this.Columns([]);
            if (result !== false) {
                this.Columns(result);
            }
        })
            .then(_ => this.Refresh())
            .then(() => {
                return this.subscribe(this.PageSize, () => {
                    if (this.PageIndex() === 0) {
                        return this.RefreshGrid();
                    } else {
                        return this.PageIndex(0);
                    }
                });
            });
    };

    canClose = () => {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    };

    setPermissions = () => {
        let permissions = this.taskVM().TaskbookPermissions;
        if (!permissions) return;
        for (let actionKey in permissions) {
            if (this.baoToolbar2TaskEvaluationShowButton) {
                this.baoToolbar2TaskEvaluationShowButton(actionKey, permissions[actionKey]);
            }
        }
    }

}
export default TaskEvaluationTab;